import { useEffect, useState } from "react";
import { Loader2, Send, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

export function NudgeDialog({ customer, onClose, onSent }) {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const [drafting, setDrafting] = useState(true);
  const draft = async () => {
    setDrafting(true);
    try { setD((await api.post(`/admin/journey/${customer.user_id}/nudge/draft`)).data); }
    catch (e) { toast.error(formatErr(e)); } finally { setDrafting(false); }
  };
  useEffect(() => { draft(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const send = async () => {
    setBusy(true);
    try { await api.post(`/admin/journey/${customer.user_id}/nudge`, { subject: d.subject, message: d.message }); toast.success(`Nudge sent to ${customer.email}`); onSent(); onClose(); }
    catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-xl" data-testid="nudge-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">Nudge {customer.company || customer.name}</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-500 -mt-2">To {customer.email}{d?.stage ? ` · stage: ${d.stage}` : ""}. Written by AI from their business details — review before sending.</p>
        {drafting && !d ? <div className="py-10 flex items-center justify-center gap-2 text-sm text-slate-500"><Loader2 className="h-4 w-4 animate-spin" />Writing a personal note...</div> : d && <>
          <Input value={d.subject} maxLength={150} onChange={(e) => setD({ ...d, subject: e.target.value })} data-testid="nudge-subject-input" />
          <Textarea rows={9} maxLength={3000} value={d.message} onChange={(e) => setD({ ...d, message: e.target.value })} data-testid="nudge-message-input" />
          <p className="text-xs text-slate-500">A "Take my next step" button linking to their next page is added automatically. Replies come to your admin inbox.</p>
          <div className="flex gap-2">
            <Button variant="outline" disabled={drafting} onClick={draft} data-testid="nudge-regenerate-button">{drafting ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <RefreshCw className="h-4 w-4 mr-2" />}Rewrite</Button>
            <Button disabled={busy || drafting || d.message.trim().length < 10} onClick={send} className="flex-1 bg-emerald-600 hover:bg-emerald-700" data-testid="nudge-send-button">{busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Send className="h-4 w-4 mr-2" />}Send nudge</Button>
          </div>
        </>}
      </DialogContent>
    </Dialog>
  );
}
